class TotaisGeraisModel {

    total_aberto: number | null;
    total_vendido: number | null;
    total_recebido: number | null;

    constructor() {
        this.total_aberto = null;
        this.total_vendido = null;
        this.total_recebido = null;
    }

}

export default TotaisGeraisModel;
